import React, { useEffect, useState } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom";
import ApplicationInstructions from "../../../Components/ApplicationInstructions";
import { getFieldData } from "../../../Services/appService";
import { getCurrentUser, getLoggedUserDetails, loadUserDetails } from "../../store/auth";
import { useDispatch, useSelector } from "react-redux";
import { Tab, Tabs } from "react-bootstrap";
import { getCandidateAppAllTasks } from "../../store/candidate";

export default function OnboardingSteps(props) {
    //const { entityType } = props;

    const [instructionShowHide, setInstructionShowHide] = useState("");
    const [entityType, setEntityType] = useState("");
    const [appStatus, setAppStatus] = useState(false);
    const [appApproved, setAppApproved] = useState(false);
    const [appAllTasks, setAllAppTasks] = useState([]);


    const usrType = localStorage.getItem("userType");
    const location = useLocation();
    const appType = location?.pathname;


    const dispatch = useDispatch();
    const currentUser = getCurrentUser();
    const userDetailsSelector = useSelector(getLoggedUserDetails);
    const candidateAppAllTasksSelector = useSelector(getCandidateAppAllTasks);

    // useEffect(() => {
    //      console.log("onboarding steps")
    //     if (!userDetailsSelector)
    //         dispatch(loadUserDetails(currentUser.id));
    // }, []);

    useEffect(() => {
        if (userDetailsSelector) {
            const entType = getFieldData(
                userDetailsSelector.performerData,
                "candidateonboardingform",
                "CandidateEntity"
            );
            setEntityType(entType);
            setAppStatus(userDetailsSelector?.appSubmit);
            setAppApproved(userDetailsSelector?.approved > 0);
        }
    }, [userDetailsSelector])

    useEffect(() => {
        setAllAppTasks(candidateAppAllTasksSelector);
    }, [candidateAppAllTasksSelector])

    const handleInstructionShowHide = () => {
        setInstructionShowHide(!instructionShowHide);
    }

    const navigate = useNavigate();

    const handleSelect = (key) => {
        navigate(key);
    };

    const allPaths = ["/Onboarding", "/ContractDocs", "/AchInfo", "/BackgroundChecks", "/ReportingDetails",
        "/OnboardingStatus", "/DynamicForm", "/TimeLogs", "/CustomReport", "/Compliance"];

    if (allPaths.indexOf(appType) > -1) {
        return <React.Fragment>
            <div className="mt-2">
                <button
                    className="btn btn-sm btn-link text-underline"
                    onClick={handleInstructionShowHide}
                >
                    <i
                        className="fa fa-hand-o-right text-black"
                    ></i>{" "}
                    Instructions for completing onboarding process
                </button>
            </div>
            <div className="mt-0">
                <Tabs
                    activeKey={appType}
                    onSelect={handleSelect}
                    id="onboarding-tabs"
                    className="mb--2 p-2 border"
                >
                    <Tab eventKey="/Onboarding" title={
                        <>
                            Onboarding Form
                            {appStatus ? <i className="fa fa-solid fa-check text-success ml-1"></i> : <i className="fa fa-solid fa-times text-warning ml-1"></i>}
                        </>
                    } />
                    <Tab eventKey="/ContractDocs" title={<>Contract Documents {appApproved ? <i className="fa fa-solid fa-check text-success ml-1"></i> : <i className="fa fa-solid fa-times text-warning ml-1"></i>}</>} />
                    {entityType !== "C2C Basis" && (
                        <Tab eventKey="/AchInfo" title={<>ACH {appApproved ? <i className="fa fa-solid fa-check text-success ml-1"></i> : <i className="fa fa-solid fa-times text-warning ml-1"></i>}</>} />
                    )}
                    {<Tab eventKey="/BackgroundChecks" title={<>Background Check {appApproved ? <i className="fa fa-solid fa-check text-success ml-1"></i> : <i className="fa fa-solid fa-times text-warning ml-1"></i>}</>} />}
                    {<Tab eventKey="/OnboardingStatus" title={<>Onboarding Status {appApproved ? <i className="fa fa-solid fa-check text-success ml-1"></i> : <i className="fa fa-solid fa-times text-warning ml-1"></i>}</>} />}
                    {<Tab eventKey="/ReportingDetails" title={<>Reporting Details {appApproved ? <i className="fa fa-solid fa-check text-success ml-1"></i> : <i className="fa fa-solid fa-times text-warning ml-1"></i>}</>} />}
                    {<Tab eventKey="/TimeLogs" title={<>Time Log {entityType !== "C2C Basis" && "and Payments"} {appAllTasks.filter(x => x.loanPhase_Desc === "Time Log").length > 0 ? <i className="fa fa-solid fa-check text-success ml-1"></i> : <i className="fa fa-solid fa-times text-warning ml-1"></i>}</>} />}
                    {<Tab eventKey="/Compliance" title={<>Compliance {appAllTasks.filter(x => x.loanPhase_Desc === "Compliance").length > 0 ? <i className="fa fa-solid fa-check text-success ml-1"></i> : <i className="fa fa-solid fa-times text-warning ml-1"></i>}</>} />}
                    {entityType !== "C2C Basis" && <Tab eventKey="/CustomReport" title={<>Reports {appAllTasks.filter(x => x.loanPhase_Desc === "Time Log").length > 0 ? <i className="fa fa-solid fa-check text-success ml-1"></i> : <i className="fa fa-solid fa-times text-warning ml-1"></i>}</>} />}

                </Tabs>
            </div>
            {/* <div className="p-3 border mt-1">
                <Link
                    to="/Onboarding"
                    className={(appType === "/Onboarding" || appType === "/DynamicForm") ? "font-weight-bold" : "text-dark"}
                >
                    Onboarding Form
                    <i
                        className="fa fa-angle-double-right mr-1 ml-1"
                    ></i>
                </Link>

                <Link
                    to="/ContractDocs"
                    className={
                        appType === "/ContractDocs" ? "font-weight-bold" : "text-dark"
                    }
                >
                    Contract Documents
                    <i
                        className="fa fa-angle-double-right mr-1 ml-1"
                    ></i>
                </Link>
                {entityType !== "C2C Basis" && (
                    <Link
                        to="/AchInfo"
                        className={
                            appType === "/AchInfo"
                                ? "font-weight-bold"
                                : "text-dark"
                        }
                    >
                        ACH Information
                        <i
                            className="fa fa-angle-double-right mr-1 ml-1"
                        ></i>
                    </Link>
                )}
                <Link
                    to="/BackgroundChecks"
                    className={
                        appType === "/BackgroundChecks"
                            ? "font-weight-bold"
                            : "text-dark"
                    }
                >
                    Background Check
                    <i
                        className="fa fa-angle-double-right mr-1 ml-1"
                    ></i>
                </Link>
                <Link
                    to="/OnboardingStatus"
                    className={
                        appType === "/OnboardingStatus"
                            ? "font-weight-bold"
                            : "text-dark"
                    }
                >
                    Onboarding Status
                    <i
                        className="fa fa-angle-double-right mr-1 ml-1"
                    ></i>
                </Link>

                <Link
                    to="/ReportingDetails"
                    className={
                        appType === "/ReportingDetails"
                            ? "font-weight-bold"
                            : "text-dark"
                    }
                >
                    Reporting Details
                </Link>

            </div> */}
            {instructionShowHide && <ApplicationInstructions
                instructionShowHide={instructionShowHide}
                handleInstructionShowHide={handleInstructionShowHide}
                entityType={entityType}
            ></ApplicationInstructions>}

        </React.Fragment>
    }

    return "";

}